import { App, Form, Select } from 'antd';
import { useState } from 'react';
import { useWatch } from 'antd/es/form/Form';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { Option } from '../../../types';

interface SelectArticleTagsProps {
  options: Option[];
  mode?: 'multiple' | 'tags';
  name?: string;
  label?: string;
}

const TAG_MAX_LENGTH = 20;

export function SelectArticleTags({ options, mode, name = 'tags', label = 'Tags' }: SelectArticleTagsProps) {
  const { message } = App.useApp();
  const [searchValue, setSearchValue] = useState('');

  const form = useFormInstance();
  const selectedTags = useWatch(name, form);

  const handleSelect = (value: string, option: Option) => {
    /** This function checks if current selected 'value' is present in 'selectedTags'.
     * To do so, it matches items from 'selectedTags' to 'options', because 'selectedTags' its just IDs.
     */
    // Example of 'value'
    // 'id1'
    //
    // Example of 'options'
    // [{
    //   "label": "id1",
    //   "value": "0b9e61cf-e55d-4b2a-a1db-7d8b0d8d015d"
    // }]
    //
    // Example of 'option'
    // {} for new tags or { label: string, value: string } for items which came from response and already was created
    //
    // Example of selectedTags:
    // ["0b9e61cf-e55d-4b2a-a1db-7d8b0d8d015d", "4a0740bd-9dc2-4d03-bb1b-22cc389db355", "id1"]

    const selectedLabels = selectedTags?.map((tag: string) => {
      /** Try to find matching option by value (existing tag) */
      const found = options.find((opt) => opt.value === tag);

      return found?.label || tag; /** fallback to tag string itself (new tags) */
    }) || [];

    const newLabel = option.label || value;

    if (selectedLabels.includes(newLabel)) {
      message.error('You already added this tag');
      /* const updatedTags = selectedTags.filter((tag: string) => {
        const found = options.find((opt) => opt.value === tag);

        return (found?.label || tag) !== newLabel;
      });

      form.setFieldValue(name, updatedTags); */
      form.setFieldValue(name, selectedTags);
    }

    setSearchValue('');
  };

  return (
    <Form.Item label={label} name={name}>
      <Select
        mode={mode}
        allowClear
        style={{ width: '100%' }}
        placeholder={label}
        onSearch={(value) => (
          setSearchValue(value.length > TAG_MAX_LENGTH ? value.trim().slice(0, TAG_MAX_LENGTH) : value)
        )}
        searchValue={searchValue}
        options={options}
        filterOption={(inputValue: string, option?: Option) => (
          !!option?.label?.toString().toLocaleLowerCase().includes(inputValue.toLowerCase())
        )}
        onSelect={mode === 'tags' ? (val, option) => handleSelect(val, option) : undefined}
      />
    </Form.Item>
  );
}

export default {
  SelectArticleTags,
};
